import { QuestionsList } from "@/features/questions";

export default function Page() {
	return <QuestionsList />;
}
